import Mutations from '../../odata/mutations';

export default { ...new Mutations('xeroPerson'), ...new Mutations('xeroPersons') };
